<template>
  <div class="password-level">
    <div class="m-r-20">密码强度</div>
    <el-progress
      class="lev"
      v-for="i in [1,2,3,4]"
      :percentage="getPercent(i)"
      :key="i"
      :color="getColor(i)"
      :stroke-width="10"
      :show-text="false"
    ></el-progress>
  </div>
</template>
<script>
import { Progress } from 'element-ui';

export default {
  name: 'PasswordLevel',
  components: { ElProgress: Progress },
  props: {
    password: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      level: 0
    };
  },
  computed: {
    getColor() {
      return status => {
        const levels = ['#f7a3a3', '#8dc5ff', '#68b2ff', '#409EFF'];
        if (this.level >= status) return levels[status - 1];
        return '#fff';
      };
    },
    getPercent() {
      return status => {
        if (this.level >= status) return 100;
        return 0;
      };
    }
  },
  watch: {
    password() {
      this.level = this.getPasswordLevel(this.password);
    }
  },
  mounted() {
    this.level = this.getPasswordLevel(this.password);
  },
  methods: {
    getPasswordLevel(password) {
      /* eslint-disable no-bitwise */
      // CharMode函数
      const CharMode = iN => {
        if (iN >= 48 && iN <= 57) {
          // 数字
          return 1;
        }
        if (iN >= 65 && iN <= 90) {
          // 大写字母
          return 2;
        }

        if ((iN >= 97 && iN <= 122) || (iN >= 65 && iN <= 90)) {
          // 大小写
          return 4;
        }
        // 特殊字符
        return 8;
      };
      // bitTotal函数
      const bitTotal = num => {
        let mumTmp = num;
        let modes = 0;
        for (let i = 0; i < 4; i += 1) {
          if (mumTmp & 1) modes += 1;
          mumTmp >>>= 1;
        }
        return modes;
      };
      let Modes = 0;
      for (let i = 0; i < password.length; i += 1) {
        Modes |= CharMode(password.charCodeAt(i));
      }
      return bitTotal(Modes);
    }
  }
};
</script>

<style lang="less">
.password-level {
  display: flex;
  align-items: center;
  > .lev {
    width: 50px;
    margin-right: 10px;
  }
}
</style>
